import React, { Component } from "react";

class KnoaRadio extends Component {
    render() {
        const {
            number,
            label,
            option,
            name,
            value,
            onChange,
            labelClass,
            ...rest
        } = this.props;

        const mergedLabelClass = `ms-2${labelClass ? ` ${labelClass}` : ''}`;

        return (
            <div className="d-flex align-items-start">
                <input
                    id={number}
                    name={name}
                    type="radio"
                    value={option}
                    checked={value === option}
                    onChange={(e) => onChange?.(e)}
                    {...rest}
                />
                <label htmlFor={number} className={mergedLabelClass}>
                    {label}
                </label>
            </div>
        );
    }
}

export default KnoaRadio;